export const stateQuestions = [
  {
    questionNumber: 1,
    questionText: "The printer has stopped working because it's out of ink.",
    choices: {
      A: "That printer is for photo printing only.",
      B: "You can borrow my stapler.",
      C: "There are extra cartridges in the drawer.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "프린터가 잉크가 떨어져서 작동을 멈췄습니다.",
      choices: {
        A: "그 프린터는 사진 인쇄용입니다.",
        B: "제 스테이플러를 빌려 드릴게요.",
        C: "서랍에 여분의 카트리지가 있습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. C는 '여분의 카트리지'라는 적절한 해결책을 제시하고 있습니다.",
  },

  {
    questionNumber: 2,
    questionText: "It's getting colder in the office these days.",
    choices: {
      A: "Let me close the window.",
      B: "The meeting is at four.",
      C: "Yes, I emailed the report.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "요즘 사무실이 점점 추워지고 있습니다.",
      choices: {
        A: "창문을 닫을게요.",
        B: "회의는 4시입니다.",
        C: "네, 보고서를 이메일로 보냈습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '창문 닫기'라는 적절한 해결책을 제시하고 있습니다.",
  },

  {
    questionNumber: 3,
    questionText: "My ID badge isn't working at the front door.",
    choices: {
      A: "I left mine at home too.",
      B: "Try entering through the side gate.",
      C: "The meeting was canceled.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "제 ID 배지가 정문에서 작동하지 않습니다.",
      choices: {
        A: "저도 제 것을 집에 두고 왔어요.",
        B: "옆문으로 들어가보세요.",
        C: "회의가 취소되었습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. B는 '옆문으로 들어가기'라는 적절한 해결책을 제시하고 있습니다.",
  },

  {
    questionNumber: 4,
    questionText: "The internet connection is really slow today.",
    choices: {
      A: "I'll reboot the router.",
      B: "The delivery hasn't arrived.",
      C: "I left my laptop at home.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 인터넷 연결이 정말 느립니다.",
      choices: {
        A: "라우터를 재부팅하겠습니다.",
        B: "배송이 아직 도착하지 않았습니다.",
        C: "제 노트북을 집에 두고 왔습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '라우터 재부팅'이라는 적절한 해결책을 제시하고 있습니다.",
  },

  {
    questionNumber: 5,
    questionText: "The projector bulb just went out.",
    choices: {
      A: "I'm going out for lunch.",
      B: "We have a spare in the cabinet.",
      C: "That's her presentation.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "프로젝터 전구가 방금 나갔습니다.",
      choices: {
        A: "점심 먹으러 나갑니다.",
        B: "캐비닛에 여분이 있습니다.",
        C: "그건 그녀의 발표입니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. B는 '여분의 전구'라는 적절한 해결책을 제시하고 있습니다.",
  },

  {
    questionNumber: 6,
    questionText: "This form doesn't have a signature.",
    choices: {
      A: "I think she forgot to sign it.",
      B: "Yes, we submitted the report.",
      C: "It's a long document.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 양식에 서명이 없습니다.",
      choices: {
        A: "그녀가 서명하는 것을 잊은 것 같습니다.",
        B: "네, 보고서를 제출했습니다.",
        C: "긴 문서입니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '서명을 잊었다'는 적절한 상황 설명을 제시하고 있습니다.",
  },

  {
    questionNumber: 7,
    questionText: "This chair feels unstable.",
    choices: {
      A: "Try tightening the screws underneath.",
      B: "The chart is color-coded.",
      C: "The manager is in her office.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 의자가 불안정하게 느껴집니다.",
      choices: {
        A: "아래쪽 나사를 조여보세요.",
        B: "차트는 색상으로 구분되어 있습니다.",
        C: "매니저는 사무실에 있습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '나사 조이기'라는 적절한 해결책을 제시하고 있습니다.",
  },

  {
    questionNumber: 8,
    questionText: "The lobby looks much brighter than before.",
    choices: {
      A: "We usually close at 6 p.m.",
      B: "They installed new ceiling lights.",
      C: "Please wait by the elevator.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "로비가 전보다 훨씬 밝아 보입니다.",
      choices: {
        A: "저희는 보통 오후 6시에 닫습니다.",
        B: "천장에 새 조명을 설치했습니다.",
        C: "엘리베이터 옆에서 기다려 주세요.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. B는 '새 천장 조명 설치'라는 상황에 대한 적절한 설명을 제공하고 있습니다.",
  },
  {
    questionNumber: 9,
    questionText: "The heating system isn't working properly.",
    choices: {
      A: "I think it's on the second shelf.",
      B: "I'll call someone to take a look.",
      C: "We ordered office supplies today.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "난방 시스템이 제대로 작동하지 않습니다.",
      choices: {
        A: "두 번째 선반에 있는 것 같습니다.",
        B: "누군가에게 확인해 보도록 전화하겠습니다.",
        C: "오늘 사무용품을 주문했습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. B는 '누군가에게 확인해 보도록 전화하겠다'는 적절한 해결책을 제시하고 있습니다.",
  },

  {
    questionNumber: 10,
    questionText: "There's a strange noise coming from the elevator.",
    choices: {
      A: "I left my phone in the meeting room.",
      B: "It's near the vending machine.",
      C: "I'll report it to building security.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "엘리베이터에서 이상한 소리가 나고 있습니다.",
      choices: {
        A: "회의실에 전화기를 두고 왔습니다.",
        B: "자판기 근처에 있습니다.",
        C: "건물 보안 담당자에게 보고하겠습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. C는 '건물 보안 담당자에게 보고하겠다'는 적절한 해결책을 제시하고 있습니다.",
  },
  {
    questionNumber: 11,
    questionText: "The conference room smells like cleaning products.",
    choices: {
      A: "The janitor just finished.",
      B: "I'll print the agenda.",
      C: "Let's take the stairs.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의실에서 청소용품 냄새가 납니다.",
      choices: {
        A: "청소부가 방금 청소를 마쳤습니다.",
        B: "회의 안건을 인쇄하겠습니다.",
        C: "계단을 이용합시다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '청소부가 방금 청소를 마쳤다'는 상황에 대한 적절한 설명을 제공하고 있습니다.",
  },
  {
    questionNumber: 12,
    questionText: "There's some water near the vending machine.",
    choices: {
      A: "I think it rained last night.",
      B: "Someone should call maintenance.",
      C: "The hallway is very quiet.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "자판기 근처에 물이 있습니다.",
      choices: {
        A: "어젯밤에 비가 온 것 같습니다.",
        B: "누군가 관리팀에 연락해야 합니다.",
        C: "복도가 매우 조용합니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. B는 '누군가 관리팀에 연락해야 한다'는 적절한 해결책을 제시하고 있습니다.",
  },
  {
    questionNumber: 13,
    questionText: "The lights in the stairwell were replaced this morning.",
    choices: {
      A: "Yes, it's much brighter now.",
      B: "Please sign here.",
      C: "I'm still waiting for the results.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "계단의 조명이 오늘 아침에 교체되었습니다.",
      choices: {
        A: "네, 지금 훨씬 더 밝아졌습니다.",
        B: "여기에 서명해 주세요.",
        C: "아직 결과를 기다리고 있습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '지금 훨씬 더 밝아졌다'는 상황에 대한 적절한 반응을 제공하고 있습니다.",
  },
  {
    questionNumber: 14,
    questionText: "The microwave is making a strange beeping noise.",
    choices: {
      A: "It's been happening all morning.",
      B: "I usually bring a salad.",
      C: "The room number is 305.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "전자레인지에서 이상한 삐 소리가 나고 있습니다.",
      choices: {
        A: "아침 내내 그런 소리가 나고 있었습니다.",
        B: "저는 보통 샐러드를 가져옵니다.",
        C: "방 번호는 305입니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '아침 내내 그런 소리가 나고 있었다'는 상황에 대한 적절한 설명을 제공하고 있습니다.",
  },
  {
    questionNumber: 15,
    questionText: "The floor in the main entrance is wet.",
    choices: {
      A: "It's probably from the rain.",
      B: "We need to finish by 3.",
      C: "It's located upstairs.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "주 출입구 바닥이 젖어 있습니다.",
      choices: {
        A: "아마도 비 때문일 겁니다.",
        B: "3시까지 끝내야 합니다.",
        C: "위층에 위치해 있습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '아마도 비 때문일 것'이라는 상황에 대한 적절한 설명을 제공하고 있습니다.",
  },
  {
    questionNumber: 16,
    questionText: "The supply cabinet was left open again.",
    choices: {
      A: "I locked it last night.",
      B: "The printer isn't responding.",
      C: "You can park in the garage.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "비품 캐비닛이 또 열려 있었습니다.",
      choices: {
        A: "어젯밤에 제가 잠갔습니다.",
        B: "프린터가 응답하지 않습니다.",
        C: "차고에 주차하실 수 있습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '어젯밤에 제가 잠갔다'는 상황에 대한 적절한 반응을 제공하고 있습니다.",
  },
  {
    questionNumber: 17,
    questionText: "There's a new couch in the lounge.",
    choices: {
      A: "I usually take the stairs.",
      B: "The printer ran out of paper.",
      C: "It looks very comfortable.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "라운지에 새 소파가 있습니다.",
      choices: {
        A: "저는 보통 계단을 이용합니다.",
        B: "프린터 종이가 떨어졌습니다.",
        C: "매우 편안해 보입니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. C는 '매우 편안해 보입니다'라는 새 소파에 대한 적절한 반응을 제공하고 있습니다.",
  },
  {
    questionNumber: 18,
    questionText: "The garbage bins are completely full.",
    choices: {
      A: "We should take them out soon.",
      B: "I think she's on vacation.",
      C: "The door was unlocked.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "쓰레기통이 완전히 가득 찼습니다.",
      choices: {
        A: "곧 그것들을 비워야 합니다.",
        B: "그녀는 휴가 중인 것 같습니다.",
        C: "문이 잠겨 있지 않았습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '곧 그것들을 비워야 한다'는 적절한 해결책을 제시하고 있습니다.",
  },
  {
    questionNumber: 19,
    questionText: "The refrigerator door won't stay closed.",
    choices: {
      A: "Try adjusting the shelf.",
      B: "The call ended early.",
      C: "Let's check the weather.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "냉장고 문이 닫힌 상태로 유지되지 않습니다.",
      choices: {
        A: "선반을 조정해 보세요.",
        B: "통화가 일찍 끝났습니다.",
        C: "날씨를 확인해 봅시다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '선반을 조정해 보라'는 적절한 해결책을 제시하고 있습니다.",
  },
  {
    questionNumber: 20,
    questionText: "There's a leak coming from the ceiling.",
    choices: {
      A: "The manager has been informed.",
      B: "He's on his lunch break.",
      C: "I sent the document yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "천장에서 물이 새고 있습니다.",
      choices: {
        A: "관리자에게 알렸습니다.",
        B: "그는 점심 시간입니다.",
        C: "어제 문서를 보냈습니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 해결책이나 대응을 답변해야 합니다. A는 '관리자에게 알렸다'는 적절한 해결책을 제시하고 있습니다.",
  },
  {
    questionNumber: 21,
    questionText: "The maintenance team replaced the lights this morning.",
    choices: {
      A: "I left the window open.",
      B: "The meeting was postponed.",
      C: "That explains why it's so bright now.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "유지보수팀이 오늘 아침에 조명을 교체했습니다.",
      choices: {
        A: "창문을 열어 두었습니다.",
        B: "회의가 연기되었습니다.",
        C: "그래서 지금 이렇게 밝은 이유가 설명되네요.",
      },
    },
    explanation:
      "상태나 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. C는 '그래서 지금 이렇게 밝은 이유가 설명되네요'라는 적절한 반응을 제시하고 있습니다.",
  },
  {
    questionNumber: 22,
    questionText: "A truck just dropped off the new desks.",
    choices: {
      A: "I'll help move them into the office.",
      B: "The door is locked.",
      C: "Desk drawers are usually deep.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "트럭이 방금 새 책상들을 내려놓았습니다.",
      choices: {
        A: "그것들을 사무실로 옮기는 것을 도와드리겠습니다.",
        B: "문이 잠겨 있습니다.",
        C: "책상 서랍은 보통 깊습니다.",
      },
    },
    explanation:
      "상태나 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. A는 '그것들을 사무실로 옮기는 것을 도와드리겠습니다'라는 적절한 대응을 제시하고 있습니다.",
  },
  {
    questionNumber: 23,
    questionText: "The projector is finally working again.",
    choices: {
      A: "You can turn off the air conditioner.",
      B: "I haven't used it in a while.",
      C: "Great, now we can start the presentation.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "프로젝터가 마침내 다시 작동합니다.",
      choices: {
        A: "에어컨을 끄셔도 됩니다.",
        B: "한동안 그것을 사용하지 않았습니다.",
        C: "좋아요, 이제 프레젠테이션을 시작할 수 있겠네요.",
      },
    },
    explanation:
      "상태나 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. C는 '좋아요, 이제 프레젠테이션을 시작할 수 있겠네요'라는 적절한 반응을 제시하고 있습니다.",
  },
  {
    questionNumber: 24,
    questionText: "A batch of uniforms was delivered this afternoon.",
    choices: {
      A: "I received my login credentials.",
      B: "I thought those were coming next week.",
      C: "Uniforms should be worn daily.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "오늘 오후에 유니폼 한 묶음이 배달되었습니다.",
      choices: {
        A: "로그인 자격 증명을 받았습니다.",
        B: "그것들이 다음 주에 올 것이라고 생각했습니다.",
        C: "유니폼은 매일 착용해야 합니다.",
      },
    },
    explanation:
      "상태나 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. B는 '그것들이 다음 주에 올 것이라고 생각했습니다'라는 적절한 반응을 제시하고 있습니다.",
  },
  {
    questionNumber: 25,
    questionText: "A set of files was emailed to the entire team.",
    choices: {
      A: "I printed them out for you.",
      B: "The team meeting is over.",
      C: "Yes, the fax number has changed.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "파일 세트가 전체 팀에게 이메일로 전송되었습니다.",
      choices: {
        A: "당신을 위해 그것들을 인쇄해 두었습니다.",
        B: "팀 회의가 끝났습니다.",
        C: "네, 팩스 번호가 변경되었습니다.",
      },
    },
    explanation:
      "상태나 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. A는 '당신을 위해 그것들을 인쇄해 두었습니다'라는 적절한 대응을 제시하고 있습니다.",
  },
  {
    questionNumber: 26,
    questionText: "The meeting agenda was sent out earlier today.",
    choices: {
      A: "We should review it before the call.",
      B: "That's the manager's office.",
      C: "I didn't get my parking pass yet.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의 안건이 오늘 일찍 발송되었습니다.",
      choices: {
        A: "통화 전에 그것을 검토해야 합니다.",
        B: "저것은 매니저의 사무실입니다.",
        C: "아직 주차 패스를 받지 못했습니다.",
      },
    },
    explanation:
      "상태나 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. A는 '통화 전에 그것을 검토해야 합니다'라는 적절한 대응을 제시하고 있습니다.",
  },
  {
    questionNumber: 27,
    questionText: "The elevator is still out of service.",
    choices: {
      A: "I left my umbrella upstairs.",
      B: "That's why people are using the stairs.",
      C: "That report is due tomorrow.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "엘리베이터가 아직 고장 상태입니다.",
      choices: {
        A: "우산을 위층에 두고 왔습니다.",
        B: "그래서 사람들이 계단을 이용하고 있습니다.",
        C: "그 보고서는 내일까지 제출해야 합니다.",
      },
    },
    explanation:
      "상태나 문제 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. B는 '그래서 사람들이 계단을 이용하고 있습니다'라는 상황에 대한 적절한 설명을 제시하고 있습니다.",
  },
  {
    questionNumber: 28,
    questionText: "The carpets were cleaned over the weekend.",
    choices: {
      A: "That's why it smells so fresh in here.",
      B: "The cleaners left a note on the desk.",
      C: "Weekend traffic was heavy.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "카펫이 주말 동안 청소되었습니다.",
      choices: {
        A: "그래서 이곳이 이렇게 상쾌한 냄새가 나는군요.",
        B: "청소부들이 책상에 메모를 남겼습니다.",
        C: "주말 교통량이 많았습니다.",
      },
    },
    explanation:
      "상태나 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. A는 '그래서 이곳이 이렇게 상쾌한 냄새가 나는군요'라는 적절한 반응을 제시하고 있습니다.",
  },
  {
    questionNumber: 29,
    questionText: "A shipment of paper cups just came in.",
    choices: {
      A: "I ordered them yesterday.",
      B: "Paper is recyclable.",
      C: "Let's put them in the pantry.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "종이컵 배송품이 방금 도착했습니다.",
      choices: {
        A: "어제 그것들을 주문했습니다.",
        B: "종이는 재활용이 가능합니다.",
        C: "그것들을 식료품 저장실에 넣읍시다.",
      },
    },
    explanation:
      "상태나 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. C는 '그것들을 식료품 저장실에 넣읍시다'라는 적절한 대응을 제시하고 있습니다.",
  },
  {
    questionNumber: 30,
    questionText: "The printer was fixed an hour ago.",
    choices: {
      A: "Did you try turning it off?",
      B: "It's still not printing.",
      C: "Good, I have documents to print.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "프린터가 한 시간 전에 수리되었습니다.",
      choices: {
        A: "전원을 꺼보셨나요?",
        B: "아직도 인쇄가 되지 않습니다.",
        C: "좋아요, 인쇄할 문서가 있습니다.",
      },
    },
    explanation:
      "상태나 상황이 제시되었을 때는 그에 대한 적절한 반응이나 대응을 답변해야 합니다. C는 '좋아요, 인쇄할 문서가 있습니다'라는 적절한 반응을 제시하고 있습니다.",
  },
];
